import Constants from "../constants"
import { horarioBonito } from "./horarioBonito"
import { fechaBonita } from "./fechaBonita"
/*
	Etiqueta del visitante en el pase de lista (Esteban, 2026-09-18).

	Un alumno que aparece en un horario que no es "suyo" llega por dos caminos:
	rotativo (mismo modulo, otro horario) o por un curso compuesto: su matricula es
	de Hoteleria pero la clase que toma AHORA es un horario de Gastronomia 1. En ese
	caso el horario del pase de lista SI es su horario actual (homeScheduleId es el
	mismo), asi que el servidor lo marca con isCourseVisitor.

	Al rotativo se le dice "Rotativo"; al de curso compuesto se le pone el nombre
	de su curso sin el "Diplomado de/en" ("Hotelería"), porque en un grupo mixto
	lo que importa es de que carrera viene, no que el curso sea compuesto.
*/

/** "Diplomado en Hotelería" -> "Hotelería". Sin prefijo se devuelve tal cual. */
export const cursoSinDiplomado = (nombre : any) : string =>
	String(nombre || "").trim().replace(/^diplomado\s+(?:de|en)\s+/i, "").trim()

/** Su horario principal es otro distinto al que se abrio. */
export const vieneDeOtroHorario = (fila : any, scheduleId : any) : boolean =>
	fila?.homeScheduleId != null
	&& Number(fila.homeScheduleId) > 0
	&& scheduleId != null
	&& Number(fila.homeScheduleId) !== Number(scheduleId)

/** Rotativo que hoy esta en un horario que no es el suyo. */
export const esRotativoVisitante = (fila : any, scheduleId : any) : boolean =>
	fila?.isRotating === true && vieneDeOtroHorario(fila, scheduleId)

/**
	Se le pone etiqueta: viene de otro horario (rotativo) o su matricula es de otro
	curso (curso compuesto), aunque este horario sea el suyo.
*/
export const esVisitanteEn = (fila : any, scheduleId : any) : boolean =>
	fila?.isCourseVisitor === true || vieneDeOtroHorario(fila, scheduleId)

/** Curso de la matricula: el servidor manda enrollmentCourseName; homeCourseName es el mismo dato viejo. */
export const cursoDeMatricula = (fila : any) : string =>
	cursoSinDiplomado(fila?.enrollmentCourseName || fila?.homeCourseName)

/**
	Texto de la pastilla: "Rotativo" si viene de otro horario; si no, el nombre corto
	de su curso. Sin scheduleId se conserva el criterio viejo (isRotating manda).
*/
export const pastillaVisitante = (fila : any, scheduleId? : any) : string =>
{
	const rotativo = scheduleId == null ? fila?.isRotating === true : esRotativoVisitante(fila, scheduleId)

	if(rotativo) return "Rotativo"

	return cursoDeMatricula(fila) || "Compuesto"
}

/** Nombre del bloque que este alumno toma en el horario abierto, si el servidor lo mando. */
export const bloqueEn = (fila : any, scheduleId : any) : string =>
{
	const nombres = fila?.blockNames
	if(!nombres || scheduleId == null) return ""

	return String(nombres[String(scheduleId)] || "").trim()
}

/**
	Asistencia transferida (Esteban, 2026-09-30): "Transferida de Domingo 9:00 am – 1:00 pm · 12 sep 2026".
	Las clases del horario nuevo anteriores a esa fecha no se le exigen.
*/
export const etiquetaTransferida = (fila : any) : string =>
{
	const origen = fila?.transferredFrom
	if(!origen) return ""
	return [Constants.Common.transferredFrom + " " + horarioBonito(origen.scheduleName), fechaBonita(origen.date)]
		.filter(Boolean).join(" · ")
}
